const META_CAPI_STORAGE_KEY = 'winitMetaCapiContext'

function readCookie(name) {
  if (typeof document === 'undefined') return undefined
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`),
  )
  if (!match?.[1]) return undefined
  try {
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}

function buildFbcFromFbclid(fbclid) {
  return `fb.1.${Date.now()}.${fbclid}`
}

function readFbclidFromUrl() {
  if (typeof window === 'undefined') return undefined
  const fbclid = new URLSearchParams(window.location.search).get('fbclid')
  return fbclid?.trim() || undefined
}

export function captureMetaCapiContext() {
  if (typeof window === 'undefined') return {}

  const existingFbc = readCookie('_fbc')
  const fbclid = readFbclidFromUrl()
  const meta_fbc = existingFbc || (fbclid ? buildFbcFromFbclid(fbclid) : undefined)
  const meta_fbp = readCookie('_fbp')
  const event_source_url = window.location.href.split('#')[0]

  const context = {
    ...(meta_fbc ? { meta_fbc } : {}),
    ...(meta_fbp ? { meta_fbp } : {}),
    ...(event_source_url ? { event_source_url } : {}),
  }

  try {
    sessionStorage.setItem(META_CAPI_STORAGE_KEY, JSON.stringify(context))
  } catch {
    // ignore quota / privacy mode
  }

  return context
}

export function getStoredMetaCapiContext() {
  if (typeof window === 'undefined') return {}
  try {
    const raw = sessionStorage.getItem(META_CAPI_STORAGE_KEY)
    if (!raw) return captureMetaCapiContext()
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object') return parsed
  } catch {
    // fall through
  }
  return captureMetaCapiContext()
}

export function initMetaCapiContext() {
  captureMetaCapiContext()
}

export function buildMetaCapiContextPayload() {
  const meta = getStoredMetaCapiContext()
  const payload = {}

  if (meta.meta_fbc) payload.fbc = meta.meta_fbc
  if (meta.meta_fbp) payload.fbp = meta.meta_fbp
  if (meta.event_source_url) payload.eventSourceUrl = meta.event_source_url

  return Object.keys(payload).length ? payload : undefined
}

export function attachMetaCapiContext(body) {
  const metaCapiContext = buildMetaCapiContextPayload()
  if (metaCapiContext) {
    body.metaCapiContext = metaCapiContext
  }
  return body
}
